export default __webpack_public_path__ + "static/illustration_caixa_preta_mobile-f5c8e06fceac0ef92e1a4eb05b5cc1e1.svg";